import { formatDate } from '@angular/common';
import {
  Component,
  OnInit,
  Inject,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-editduedatedialog',
  templateUrl: './editduedatedialog.component.html',
  styleUrls: ['./editduedatedialog.component.scss'],
})
export class EditduedatedialogComponent implements OnInit {
  public today: Date = new Date();
  public maxDate: Object = new Date(this.today);
  isValidTime: boolean = false;
  @ViewChild("timeInput") inputEl: ElementRef;
  @Output() event = new EventEmitter<any>();
  selectedStart: Date;
  selectedEnd: Date;
  minDate: Date;
  chosenDateFlag: boolean = false;
  obj: any = {};
  isAMFlag: boolean = false;
  modifiedTime: string = '';
  minDueDate: Date = new Date();
  modifiedDueDate: any;
  isValidSubmission: boolean = false;
  minTime: any;
  overCurrTime: boolean = false;
  overCurrTimeDt : boolean = false;
  finalHour: number | any;
  finalMinutes: number | any;
  curMin: number | any;
  initialTime: string = '';
  userInputMinKey: number | any;
  upDownKeyPressed: boolean = false;
  errorMessage: string = '';
  constructor(
    public dialogRef: MatDialogRef<EditduedatedialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetector: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.modifiedDueDate = new Date();
    let curHour = this.today.getHours();
    this.isAMFlag = curHour <= 12 ? true : false;
    this.finalHour = this.hoursIn12(curHour);
    this.curMin = new Date().getMinutes();
    let minutes = this.curMin + 1;
    let modifiedMin = minutes < 10 ? '0' + minutes : minutes;
    let totalTime = this.finalHour + ':' + modifiedMin;
    this.initialTime = totalTime;
    this.onTimeChange();
  }
  ngAfterContentChecked(): void {
    if (this.modifiedDueDate <= this.minDueDate && !this.overCurrTime) {
      this.overCurrTimeDt = true;
    }else {
      this.overCurrTimeDt = false;
    }
    this.changeDetector.detectChanges();
  }
  disableWeekendsFilter = (d: Date): boolean => {
    return d.getDay() !== 0 && d.getDay() !== 6;
  };
 /**
  * The function onSubmit() formats and converts a time and date into a specific format and returns it
  * to the calling function.
  */
  onSubmit(): void {
    let ampmFlag = this.isAMFlag ? 'AM' : 'PM';
    let time = this.modifiedTime + ' ' + ampmFlag;
    let updatedDateTime = this.convertTime12to24(time); 
    updatedDateTime = new Date(updatedDateTime);
    const utcDateTime = new Date(updatedDateTime.getTime() + updatedDateTime.getTimezoneOffset() * 60000); // Convert to local timezone
    const dateAPI = formatDate(utcDateTime, 'MM/dd/yyyy HH:mm:ss', 'en-US');
    this.dialogRef.close(dateAPI);
  }
 /**
  * The function updates the modified time and checks if it is before the current time and due date.
  * @param event - an object representing the change event that occurred on the time input field. It
  * contains information such as the new value of the input field.
  */
  onTimeChange(event?) {
    this.errorMessage = '';
    if(!event) { 
      event = { value: this.initialTime } 
    }
    this.overCurrTime = false;
    if(!event.value) {
      this.initialTime = '';
      this.overCurrTime = true;
      return;
    }
    if(this.userInputMinKey && (this.userInputMinKey != event.value.split(':')[0] && 
        (event.value.split(':')[0]).indexOf(this.userInputMinKey) != 1) && (event.value.split(':')[0] > 12 || event.value.split(':')[0] == 0)) {
      if(event.value.split(':')[0] == 0) {
        event.value = '12:' + event.value.split(':')[1] 
      } else if(event.value.split(':')[0] > 12 && event.value.split(':')[0] < 22) {
        event.value = '0' + (event.value.split(':')[0] - 12) + ':' + event.value.split(':')[1];
      } else {
        event.value = (event.value.split(':')[0] - 12) + ':' + event.value.split(':')[1] ;
      }
    }
    if(!this.initialTime && event.value) {
      this.initialTime = event.value;
    }
    let [hours, minutes] = event.value.split(':');
    if((minutes == 59 && parseInt(this.initialTime.split(':')[1]) != 59) && !this.upDownKeyPressed) {
      this.finalMinutes = this.initialTime.split(':')[1];
      this.inputEl.nativeElement.blur();
      this.overCurrTime = true;
      this.errorMessage = 'Value must be 12:00 or earlier.';
    } else {
      this.finalMinutes = minutes;
    }
    if((hours > 1 && hours < 13)) {
      this.initialTime = hours + ':' + this.finalMinutes;
    }
    if (hours > 12 && !this.upDownKeyPressed) {
      this.finalHour = this.initialTime.split(':')[0];
      this.overCurrTime = true;
      this.errorMessage = 'Value must be 12:00 or earlier.';
    } else {
      this.finalHour = this.hoursIn12(hours);
      this.initialTime = this.finalHour + ':' + this.finalMinutes;
    }
    this.setFinalTime();
    // if (hours > 12 || hours == 0) {
    //   this.overCurrTime = true;
    // }else {
    //   this.overCurrTime = false;
    // }
  }
  /**
   * Function to capture key up events
   */
  onKeyUpChange(event) {
    this.errorMessage = '';
    this.upDownKeyPressed = (event.keyCode == '38' || event.keyCode == '40') ? true : false;
    if(!event.target?.validity?.valid) {
      this.errorMessage = 'Value must be 12:00 or earlier.';
    }
    this.userInputMinKey = parseInt(event.key);
  }

  /**
   * Function to set the finalized time
   */
  setFinalTime() {
    let changedTime = this.finalHour + ':' + this.finalMinutes;
    this.modifiedTime = changedTime;
    let ampmFlag = this.isAMFlag ? 'AM' : 'PM';
    let time = this.modifiedTime + ' ' + ampmFlag;
    this.convertTime12to24(time);
  }
  /**
   * Method to convert hours to 12 hour format
   */
  hoursIn12(currentHour) {
    if (currentHour || currentHour == 0) {
      let hoursIn24 = currentHour % 12;
      if (hoursIn24 == 0) {
        return 12;
      } else if (hoursIn24 < 10) {
        return '0' + hoursIn24;
      } else {
        return hoursIn24;
      }
    } else {
      return "";
    }
  }
 /**
  * The function converts a time in 12-hour format to 24-hour format in TypeScript.
  * @param time12h - A string representing a time in 12-hour format, with a space separating the time
  * and the AM/PM modifier. Example: "03:30 PM".
  * @returns a string in the format of "HH:MM:SS" representing the input time in 24-hour format.
  */
  convertTime12to24(time12h) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if(!hours || !minutes) { return; }
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    let seconds = 0;
    return this.modifiedDueDate.setHours(hours, minutes, seconds);
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  
}
